import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { Button } from 'antd';

// Request demo button
function RequestButton() {
  return (
    <Link to="/contacts">
      <Button className="request__button" type="primary" size="large">
        <FormattedMessage
          id="landing.requestButton"
          defaultMessage="Request a demo"
          description="Button for request a demo"
        />
      </Button>
    </Link>
  );
}

export default RequestButton;



// WEBPACK FOOTER //
// ./src/components/landing/common/RequestButton.js